import { ButtonHTMLAttributes } from "react";
import { Image } from "shared/components/atoms/Image";

interface Props {
  className?: string;
}

export const Button = (
  props: Props & ButtonHTMLAttributes<HTMLButtonElement>
) => {
  return (
    <button type="button" tw="w-full reflective after:reflection" {...props}>
      <Image
        src={`${process.env.NEXT_PUBLIC_CDN_V2}/lp/2/button-image.png`}
        width={724}
        height={188}
        layout="responsive"
        unoptimized
      />
    </button>
  );
};
